import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/planet"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01088 13.9987C8.00522 13.9999 8.00212 14 8 14C7.99788 14 7.99478 13.9999 7.98912 13.9987C7.98321 13.9975 7.97087 13.9945 7.95139 13.9865C7.9119 13.9703 7.83789 13.9317 7.7347 13.8444C7.51906 13.662 7.23902 13.3196 6.96043 12.7624C6.49985 11.8413 6.145 10.5345 6.03535 9H9.96465C9.855 10.5345 9.50015 11.8413 9.03957 12.7624C8.76098 13.3196 8.48094 13.662 8.2653 13.8444C8.16211 13.9317 8.0881 13.9703 8.04861 13.9865C8.02913 13.9945 8.01679 13.9975 8.01088 13.9987ZM9.96465 7H6.03535C6.145 5.46553 6.49985 4.15873 6.96043 3.23757C7.23902 2.68039 7.51906 2.33804 7.7347 2.15562C7.83789 2.06834 7.9119 2.02968 7.95139 2.01352C7.97087 2.00555 7.98321 2.00248 7.98912 2.00128C7.99478 2.00013 7.99788 2 8 2C8.00212 2 8.00522 2.00013 8.01088 2.00128C8.01679 2.00248 8.02913 2.00555 8.04861 2.01352C8.0881 2.02968 8.16211 2.06834 8.2653 2.15562C8.48094 2.33804 8.76098 2.68039 9.03957 3.23757C9.50015 4.15873 9.855 5.46553 9.96465 7ZM11.9691 9C11.8707 10.5769 11.5429 12.0114 11.0546 13.1653C12.5445 12.2823 13.6196 10.773 13.917 9H11.9691ZM13.917 7H11.9691C11.8707 5.42305 11.5429 3.98864 11.0546 2.83465C12.5445 3.71766 13.6196 5.227 13.917 7ZM4.03095 7C4.12927 5.42305 4.45707 3.98864 4.94542 2.83465C3.45545 3.71766 2.38041 5.227 2.08296 7H4.03095ZM2.08296 9C2.38041 10.773 3.45545 12.2823 4.94542 13.1653C4.45708 12.0114 4.12927 10.5769 4.03095 9H2.08296ZM16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Planet16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Planet16 = createIcon(IconComponent);